



































































import { $store } from "@/store";
import {
  LayoutInsert,
  LayoutInsertType,
  layoutInsertTypes,
} from "@/store/layout/types";
import { Vue, Component, Watch } from "vue-property-decorator";
import { $appearance } from "../../store/appearance/store";

@Component
export default class LayoutInsertList extends Vue {
  get scrollElem() {
    return document.getElementById("pdfviewer-container");
  }

  get hideInsertDetails() {
    return $appearance.hideInsertDetails;
  }

  get currentPage() {
    return $store.wizard.layoutPage;
  }

  get inserts() {
    return $store.layouts.layout.inserts;
  }

  get selectedInsert() {
    return $store.wizard.selectedInsert;
  }

  set selectedInsert(val) {
    $store.wizard.selectedInsert = val;
    if (typeof val == "number") {
      const insert = this.inserts[val];
      if (this.scrollElem && this.currentPage != insert.page)
        this.scrollElem.scrollTop = 0;
      $store.wizard.layoutPage = insert.page;
      setTimeout(() => {
        document.getElementById(insert.ref)?.scrollIntoView();
      }, 100);
    }
  }

  get allowInsertDelete() {
    return !!$store.wizardInstances.wizardInstance?.config.layout
      ?.allowInsertDelete;
  }

  get allowInsertCreate() {
    return !!$store.wizardInstances.wizardInstance?.config.layout
      ?.allowInsertCreate;
  }

  get insertListHeight() {
    return `${$store.appearance.PDFVIEWERTOOLBAR_HEIGHT - 70}px`;
  }

  toggleInsertDetails() {
    $appearance.hideInsertDetails = !$appearance.hideInsertDetails;
  }

  addLayoutInsert() {
    const [, insert] = $store.layouts.addInsert(this.currentPage);
    $store.wizard.selectedInsert = this.inserts.length - 1;
    setTimeout(() => {
      document.getElementById(insert.ref)?.scrollIntoView();
    }, 100);
  }

  removeLayoutInsert(idx: number) {
    $store.layouts.removeInsert(idx);
  }

  insertTypeToText(type: LayoutInsertType) {
    return layoutInsertTypes.find((t) => t.value == type)?.text || type;
  }

  @Watch("inserts", { deep: true })
  handleInsertsChange(val: LayoutInsert[], oldVal: LayoutInsert[]) {
    if (oldVal && oldVal.length == 0 && val && val.length > 0)
      this.selectedInsert = 0;
  }
}
